import { render, staticRenderFns } from "./ActivationBriefSubmissionCountdown.vue?vue&type=template&id=36f29872&"
import script from "./ActivationBriefSubmissionCountdown.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefSubmissionCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports